import Fingerprint2 from "fingerprintjs2";



import { logInformation } from "@/shared/logging/informations";


export class DeviceFingerprintProvider {
    public static getFingerprint(): Promise<string> {
        const options = {
            excludes: {
                canvas: true,
                webgl: true,
                audio: true,
            },
        };
        return new Promise((resolve) => {
            if (window.requestIdleCallback !== undefined) {
                window.requestIdleCallback(() => {
                    Fingerprint2.get(options, (components) => {
                        const values = components.map((component) => {
                            return component.value;
                        });
                        const fingerprint = Fingerprint2.x64hash128(values.join(""), 31);
                        logInformation("Fingerprint: " + fingerprint);
                        resolve(fingerprint);
                    });
                    // a hidden tab gets no idle time, so without a timeout this waited until the tab came back -
                    // minutes in which a kiosk session reset sat between its sign-out and the new session
                }, { timeout: 1000 });
            } else {
                setTimeout(() => {
                    Fingerprint2.get(options, (components) => {
                        const values = components.map((component) => {
                            return component.value;
                        });
                        const fingerprint = Fingerprint2.x64hash128(values.join(""), 31);
                        logInformation("Fingerprint: " + fingerprint);
                        resolve(fingerprint);
                    });
                }, 500);
            }
        });
    }
}
